import amber from '@material-ui/core/colors/amber';
import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import { createGlobalStyle } from 'styled-components';
import 'typeface-roboto';

export const dapTheme = {
  palette: {
    primary: {
      main: '#0f0b0b',
    },
    secondary: { main: '#86bc24' },
    success: { main: green[400] },
    warning: { main: amber[700] },
    error: { main: red[500] },
    info: { main: blue[300] },
    button: {
      main: grey[600],
      light: grey[400],
      dark: grey[800],
    },
    text: {
      primary: '#0f0b0b',
    },
  },
  typography: {
    htmlFontSize: 10,
    fontFamily: 'Roboto',
    useNextVariants: true,
  },
  drawer: {
    configuration: {
      width: 285,
    },
  },
};

export const GlobalStyle = createGlobalStyle`
    html {
      font-size: 62.5%; /* 62.5% of 16px = 10px */
    }
    body {
      font-size: 1.6rem;
    }
    h1 {
      ${props => props.theme.typography.h1};
    }
    h2 {
      ${props => props.theme.typography.h2};
    }
    h3 {
      ${props => props.theme.typography.h3};
    }
    h4 {
      ${props => props.theme.typography.h4};
    }
    h5 {
      ${props => props.theme.typography.h5};
    }
    h6 {
      ${props => props.theme.typography.h6};
    }
  `;
